/*
 * Wish Dance — motion
 * Un solo IntersectionObserver per tutta la pagina. Nessuna libreria.
 * Se il JS non parte, il CSS lascia il contenuto visibile (la classe .wd-js
 * viene messa qui: senza di essa nessun elemento e mai nascosto).
 */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  document.documentElement.classList.add('wd-js');

  function observe() {
    var nodes = document.querySelectorAll('[data-wd-reveal]:not(.wd-in)');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('wd-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('wd-in');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (n) {
      var group = n.closest('[data-wd-stagger]');
      if (group) {
        var siblings = group.querySelectorAll('[data-wd-reveal]');
        n.style.setProperty('--wd-i', Array.prototype.indexOf.call(siblings, n));
      } else {
        n.style.setProperty('--wd-i', 0);
      }
      io.observe(n);
    });
  }

  /*
   * Video sotto la piega: si caricano solo quando entrano in vista.
   * data-wd-src evita che il browser scarichi il file al parsing.
   */
  function lazyVideo() {
    var vids = document.querySelectorAll('video[data-wd-src]');
    if (!vids.length) return;

    function load(v) {
      // Video riservati al desktop: sotto la soglia non si scaricano mai.
      var min = parseInt(v.getAttribute('data-wd-min-width'), 10);
      if (min && window.innerWidth < min) return;

      if (v.dataset.wdSrc) {
        v.src = v.dataset.wdSrc;
        delete v.dataset.wdSrc;
        v.load();
      }
      if (v.hasAttribute('data-wd-autoplay')) {
        var p = v.play();
        if (p && p.catch) p.catch(function () { /* autoplay negato: resta il poster */ });
      }
    }

    if (!('IntersectionObserver' in window)) {
      vids.forEach(load);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px' });

    vids.forEach(function (v) { io.observe(v); });
  }

  /*
   * Contatori (2026-09-17): [data-wd-count="1985"] parte da 0 quando entra in vista.
   * Il markup porta gia' il valore finale nel testo: senza JS o con reduced-motion
   * (lo script esce in testa) resta scritto. data-wd-decimals, data-wd-suffix,
   * data-wd-group="0" per gli anni (1985, non 1.985).
   */
  function countUp() {
    var nodes = document.querySelectorAll('[data-wd-count]:not(.wd-counted)');
    if (!nodes.length) return;
    var lang = document.documentElement.lang || 'it';

    function run(el) {
      el.classList.add('wd-counted');
      var target = parseFloat(el.getAttribute('data-wd-count'));
      if (isNaN(target)) return;
      var decimals = parseInt(el.getAttribute('data-wd-decimals') || '0', 10);
      var suffix = el.getAttribute('data-wd-suffix') || '';
      var group = el.getAttribute('data-wd-group') !== '0';
      var dur = 1100, t0 = null;
      function fmt(v) {
        return v.toLocaleString(lang, { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping: group }) + suffix;
      }
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * e);
        if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target);
      }
      el.textContent = fmt(0);
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('wd-counted'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        run(entry.target);
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    nodes.forEach(function (n) { io.observe(n); });
  }

  /*
   * Nastri (.wd-marquee): pulsante pausa/riprendi (WCAG 2.2.2 — hover e focus non
   * bastano a chi usa touch o tastiera). Etichette da data-wd-pause / data-wd-play,
   * messe da Liquid nella lingua della pagina. Con reduced-motion questo script non
   * parte e il nastro e' gia' fermo: nessun pulsante.
   */
  function marqueeControls() {
    var nodes = document.querySelectorAll('.wd-marquee:not(.wd-marquee--ctl)');
    if (!nodes.length) return;
    var ICONS = '<svg class="wd-i-pause" viewBox="0 0 10 10" aria-hidden="true"><rect x="1" y="1" width="3" height="8"/><rect x="6" y="1" width="3" height="8"/></svg>' +
                '<svg class="wd-i-play" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 1l7 4-7 4z"/></svg>';
    nodes.forEach(function (m) {
      m.classList.add('wd-marquee--ctl');
      var pauseLabel = m.getAttribute('data-wd-pause') || 'Ferma lo scorrimento';
      var playLabel = m.getAttribute('data-wd-play') || 'Riprendi lo scorrimento';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wd-marquee__pause';
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', pauseLabel);
      b.innerHTML = ICONS;
      b.addEventListener('click', function () {
        var paused = m.classList.toggle('is-paused');
        b.setAttribute('aria-pressed', paused ? 'true' : 'false');
        b.setAttribute('aria-label', paused ? playLabel : pauseLabel);
      });
      m.appendChild(b);
    });
  }

  function init() {
    observe();
    lazyVideo();
    countUp();
    marqueeControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Il theme editor ricarica le sezioni senza ricaricare la pagina.
  document.addEventListener('shopify:section:load', init);
})();
